<template>
  <div class="qmkey-side-panel">
    <!-- Right position -->
    <div 
      v-if="right"
      :class="(panel ? 'rigth-panel-opened' : '')" 
      class="panel-button right-panel"
    >
      <v-btn
        @click.stop="panel = !panel"
        icon
        rounded
        :class="panel ? 'panel-button-opened' : 'panel-closed-button'"
      >
        <v-icon >{{ panel ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
      </v-btn>
    </div>
    <v-navigation-drawer
      v-model="panel"
      :absolute="is_mobile"
      hide-overlay
      :mini-variant="small"
      :right="right"
      class="qmkey-side-drawer"
      :class="panel ? 'opened-drawer' : 'closed-drawer'"
    >
      <div 
        class="navigation-drawer-content"
        :class="is_mobile ? 'navigation-drawer-content-mobile' : ''"
      >
        <component
          v-for="(act, index) in whitelist"
          :key="act.component+'_'+index"
          :is="act.component"
          :filters="filters"
          :is_mobile="is_mobile"
          :size="act.size"
          :icon_size="act.icon_size"
          @update="update_filters"
        />
      </div>
    </v-navigation-drawer>
    <!-- Left position -->
    <div 
      v-if="!right"
      :class="(panel ? 'left-panel-opened' : '')" 
      class="panel-button left-panel"
    >
      <v-btn
        @click.stop="panel = !panel"
        icon
        rounded
        :class="panel ? 'panel-button-opened' : 'panel-button-closed'"
      >
        <v-icon >{{ panel ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style>
  .qmkey-side-panel {
    max-width: 100%;
    max-height: 100%;
    position: static;
    z-index: 1;
    width: fit-content;
    align-items: top;
    display: flex;
  }
  .qmkey-side-drawer {
    display: inline;
    top: 0px;
    bottom: 0px;
  }
  .closed-drawer {
    width: 0px !important;
  }
  .opened-drawer {
    width: fit-content !important;
  }
  .navigation-drawer-content {
    margin: auto;
    align-items: center;
    display: flex;
    padding-top: 2vw;
    padding-bottom: 2vw;
    z-index: 1;
  }
  .panel-button {
    width: fit-content;
    display: inline;
    z-index: 1;
  }
  .panel-button-closed {
    position: fixed !important;
    background-color:#f0f0f0 !important;
  }
  .panel-button-opened {
    position: relative !important;
    background-color:#f0f0f0 !important;
  }
</style>

<script>
  import ExplorerDirectoryMobile from '@/components/explorer/ExplorerDirectoryMobile';
  import ExplorerDirectory from '@/components/explorer/ExplorerDirectory';
  export default {
    name: 'SidePanel',

    components: {
      ExplorerDirectoryMobile,
      ExplorerDirectory,
    },

    props: {
      filters: {},
      is_mobile: {type: Boolean, defalut: false},
      items: {},
      small: {type: Boolean, default: false},
      //TODO: right parameter is not working
      right: {type: Boolean, default: false},
    },
    data: () => ({
      panel: false,
      default_items: [
        {
          component: 'ExplorerDirectory',
          size: 'small',
          icon_size: 'large',
        },
      ],
    }),

    computed: {
      whitelist() {
        return this.items || this.default_items;
      },
    },

    methods: {
      close() {
        this.panel = false;
      },
      update_filters(new_filters) {
        this.$emit('update_filters',new_filters);
      },
    },
  }
</script>